import React, { useState } from 'react';
import './QuestionInput.css';

function QuestionInput({ onSubmit }) {
  const [question, setQuestion] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(question);
  };

  return (
    <div className="question-input-container">
      <h1 className="input-title">What are you trying to figure out?</h1>
      <p className="input-subtitle">ask the girlies who've been there and done that</p>
      
      <form onSubmit={handleSubmit} className="input-form">
        <textarea
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Type your fertility question here..."
          className="input-textarea"
        />
        <button type="submit" className="submit-button">
          ask for advice
        </button>
      </form>
    </div>
  );
}

export default QuestionInput; 